"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.number.constructor.js");
var _icon = _interopRequireDefault(require("../icon"));
var _divider = _interopRequireDefault(require("../divider"));
var POSITIONS = ['top', 'bottom', 'left', 'right'];
var _default2 = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "z-tip-trigger",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.toggleVisibleWrapper($event);
        }
      }
    }, [_vm._t("default"), _c('transition', {
      attrs: {
        "name": "z-bounce"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isVisible,
        expression: "isVisible"
      }],
      class: ['z-tip', {
        'z-tip-custom': _vm.custom
      }],
      style: _vm.style
    }, [_c('i', {
      class: ["" + _vm.position, "z-tip-angle", {
        'z-tip-angle-custom': _vm.custom
      }],
      style: _vm.arrowPosition
    }), _vm.showClose ? _c('z-icon', {
      class: ["" + (_vm.custom ? 'z-tip-close-custom' : 'z-tip-close'), ''],
      attrs: {
        "name": "close",
        "class-prefix": "zziconfont-6"
      }
    }) : _vm._e(), _vm.menu.length > 0 ? _c('div', {
      staticClass: "z-tip-menu"
    }, _vm._l(_vm.menu, function (item, index) {
      return _c('div', {
        key: index
      }, [_c('div', {
        directives: [{
          name: "clickeffect",
          rawName: "v-clickeffect"
        }],
        on: {
          "click": function click($event) {
            $event.stopPropagation();
            return _vm.menuClick(item, item.key);
          }
        }
      }, [_vm._v(_vm._s(item.label))]), index != _vm.menu.length - 1 ? _c('z-divider') : _vm._e()], 1);
    }), 0) : _c('div', {
      class: ['z-tip-content', {
        'z-tip-content-custom': _vm.custom
      }]
    }, [_vm._t("tip", [_vm._v(_vm._s(_vm.tip))])], 2)], 1)])], 2);
  },
  name: 'z-tip',
  components: {
    'z-icon': _icon.default,
    'z-divider': _divider.default
  },
  model: {
    prop: 'visible',
    event: 'toggle'
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    menu: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showClose: {
      type: Boolean,
      default: true
    },
    closeOnBody: {
      type: Boolean,
      default: false
    },
    tip: String,
    custom: Boolean,
    position: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return POSITIONS.includes(val);
      }
    },
    maxWidth: [Number, String],
    offsetTop: {
      type: Number,
      default: 0
    },
    offsetLeft: {
      type: Number,
      default: 0
    },
    arrowOffsetTop: {
      type: Number,
      default: 0
    },
    arrowOffsetLeft: {
      type: Number,
      default: 0
    },
    banClick: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isVisible: true,
      width: 0,
      height: 0,
      style: {
        visibility: 'hidden',
        maxWidth: typeof this.maxWidth === 'string' ? this.maxWidth : typeof this.maxWidth === 'number' ? this.maxWidth + 'px' : undefined
      }
    };
  },
  computed: {
    arrowPosition: function arrowPosition() {
      switch (this.position) {
        case 'top':
        case 'bottom':
          return {
            left: this.width / 2 + this.arrowOffsetLeft + "px"
          };
        case 'left':
        case 'right':
        default:
          return {
            top: this.height / 2 + this.arrowOffsetTop + "px"
          };
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    // 先使其可见，获取到高宽之后才隐藏
    this.$nextTick(function () {
      var _this$$el$querySelect = _this.$el.querySelector('.z-tip'),
        clientWidth = _this$$el$querySelect.clientWidth,
        clientHeight = _this$$el$querySelect.clientHeight;
      _this.width = clientWidth;
      _this.height = clientHeight;
      _this.init();
    });
    if (!this.closeOnBody) {
      document.addEventListener('click', this.hide);
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.hide);
  },
  methods: {
    menuClick: function menuClick(item, key) {
      this.$emit('menuClick', item, key);
    },
    show: function show() {
      console.log('this.isVisible', this.isVisible);
      if (!this.isVisible) {
        this.isVisible = true;
        this.$emit('show');
      }
    },
    hide: function hide() {
      if (this.isVisible) {
        this.isVisible = false;
        this.$emit('hide');
      }
    },
    toggleVisibleWrapper: function toggleVisibleWrapper() {
      if (this.banClick) return;
      this.toggleVisible();
    },
    toggleVisible: function toggleVisible() {
      console.log(this.isVisible);
      if (this.isVisible) {
        this.hide();
      } else {
        this.initPosition();
        this.show();
      }
    },
    init: function init() {
      if (this.visible) {
        this.initPosition();
        this.isVisible = true;
      } else {
        this.isVisible = false;
      }
    },
    initPosition: function initPosition() {
      delete this.style.visibility;
      switch (this.position) {
        case 'top':
          this.style.top = -this.height - 10 + this.offsetTop + "px";
          this.style.left = (this.$el.clientWidth - this.width) / 2 + this.offsetLeft + "px";
          break;
        case 'bottom':
          this.style.top = this.$el.clientHeight + 10 + this.offsetTop + "px";
          this.style.left = (this.$el.clientWidth - this.width) / 2 + this.offsetLeft + "px";
          break;
        case 'left':
          this.style.top = (this.$el.clientHeight - this.height) / 2 + this.offsetTop + "px";
          this.style.left = -this.width - 10 + this.offsetLeft + "px";
          break;
        case 'right':
          this.style.top = (this.$el.clientHeight - this.height) / 2 + this.offsetTop + "px";
          this.style.left = this.$el.clientWidth + 10 + this.offsetLeft + "px";
          break;
      }
    }
  }
};
exports.default = _default2;